module.exports = __webpack_public_path__ + "bb5.no1.d9ff5961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb5.no1.jpg
// module id = if/X
// module chunks = 0